import { MapGroupId } from "../../types";
import img from "../../mapImages/LabsMain.webp";

const mapData = {
  groupId: MapGroupId.Labs,
  groupName: {
    en: "Labs",
    ru: "Лаборатория",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
